(function () {
  var TRIGGER_HASH = '#scroll-to-loox';
  var LOOX_SELECTOR = '#looxReviews'; // change if your Loox widget uses a custom wrapper
  var MAX_WAIT = 8000;                 // stop polling after 8s
  var POLL_INTERVAL = 200;

  if (window.location.hash !== TRIGGER_HASH) return;

  var start = Date.now();
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getHeaderOffset() {
    var header = document.querySelector('.header, .header-wrapper, header[role="banner"]');
    return header ? header.offsetHeight + 20 : 20;
  }

  function scrollToLoox(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: top, behavior: prefersReduced ? 'auto' : 'smooth' });
    // Clean the hash so refresh / back button doesn't re-trigger
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  function poll() {
    var el = document.querySelector(LOOX_SELECTOR);
    // Wait until the widget has actually rendered (has real height)
    if (el && el.offsetHeight > 50) {
      scrollToLoox(el);
      return;
    }
    if (Date.now() - start > MAX_WAIT) {
      if (el) scrollToLoox(el); // fallback: scroll even if still small
      return;
    }
    setTimeout(poll, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();